import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import {
  ManageLocationsRootParamList,
  SettingsRootParamList,
} from "../../../../types";
import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import { ManageLocationsScreen } from "./ManageLocationsScreen";
import { EditLocationScreen } from "./EditLocationScreen";

const Stack = createStackHeaderNavigator<ManageLocationsRootParamList>();

export interface ManageLocationsRootScreenScreenProps
  extends StackScreenProps<
    SettingsRootParamList,
    "ManageLocationsRootScreen"
  > {}

export const ManageLocationsRootScreen =
  ({}: ManageLocationsRootScreenScreenProps) => {
    return (
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <Stack.Group
          screenOptions={{
            title: "",
            headerLeft: () => <ModalCloseButton type="Back" />,
          }}
        >
          <Stack.Screen
            name="ManageLocationsScreen"
            component={ManageLocationsScreen}
          />
          <Stack.Screen
            name="EditLocationScreen"
            component={EditLocationScreen}
            options={{
              headerShown: false,
              title: "",
            }}
          />
        </Stack.Group>
      </Stack.Navigator>
    );
  };
